"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rebass_1 = require("rebass");
const styled_system_1 = require("styled-system");
exports.default = rebass_1.Box.extend `
  ${styled_system_1.display}
  ${styled_system_1.height}
  ${styled_system_1.position}
  ${styled_system_1.opacity}
`;



// WEBPACK FOOTER //
// ./src/components/div.tsx